export default __webpack_public_path__ + "static/media/logo-noname.d3582298.webp";